import { 
    ModuleRegistry, 
    ClientSideRowModelModule,
    CellStyleModule,
    DateFilterModule,
    TextFilterModule,
    RowAutoHeightModule,
    PaginationModule,
    ColumnApiModule,
    RowSelectionModule
} from 'ag-grid-community';
import {
    ServerSideRowModelModule,
    ValidationModule,
    CellSelectionModule,
    SideBarModule,
    StatusBarModule,
    ColumnMenuModule,
    ColumnsToolPanelModule,
    FiltersToolPanelModule,
    ExternalFilterModule,
    EventApiModule
} from 'ag-grid-enterprise';

// Register AG Grid Modules
ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    ServerSideRowModelModule,
    ValidationModule,
    CellStyleModule,
    DateFilterModule,
    TextFilterModule,
    RowAutoHeightModule,
    CellSelectionModule,
    SideBarModule,
    StatusBarModule,
    ColumnMenuModule,
    PaginationModule,
    ColumnApiModule,
    ColumnsToolPanelModule,
    FiltersToolPanelModule,
    RowSelectionModule,
    ExternalFilterModule,
    EventApiModule
]);

// Common grid options that can be reused across components
export const defaultGridOptions = {
    defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        suppressHeaderMenuButton: true
    },
    rowSelection: 'multiple'
};
